// MUI component overrides for Mantis theme
import Button from './Button';
import Card from './Card';
import IconButton from './IconButton';
import InputLabel from './InputLabel';
import OutlinedInput from './OutlinedInput';
import Tab from './Tab';
import Tabs from './Tabs';
import TableCell from './TableCell';

export default function ComponentsOverrides(theme: any) {
  return Object.assign(
    Button(theme),
    Card(theme),
    IconButton(),
    InputLabel(theme),
    OutlinedInput(theme),
    Tab(theme),
    Tabs(),
    TableCell(theme)
  );
}
